/**
 * Regras de layout do HERO do orçamento (o cabeçalho verde sangrado).
 *
 * Existe para as telas de criação e de edição não divergirem: as duas desenham
 * o mesmo cabeçalho, e uma regra de tamanho copiada nas duas é a receita para
 * uma delas ser ajustada e a outra não.
 */

/**
 * Classe de tamanho do TOTAL, escolhida pelo comprimento do valor formatado.
 *
 * ─── POR QUE NÃO É SEMPRE `text-3xl` ────────────────────────────────────────
 *
 * O total divide a linha com a coluna do número (124px medidos), sobrando 192px
 * em uma tela de 360. Como o elemento tem `truncate`, o excesso não quebra
 * linha: ele SOME. O usuário leria "R$ 1.284.50…" — o número mais importante da
 * tela, cortado exatamente nos documentos de maior valor (irmão da armadilha
 * #52, em que o selo comia o nome do produto).
 *
 * Larguras MEDIDAS no browser embutido a 360px (não estimadas), por tamanho:
 *
 *   valor formatado      len   3xl    2xl    xl
 *   "R$ 60,00"            8    122     98     82
 *   "R$ 60.000,00"       12    182 ✓  146     121
 *   "R$ 128.450,00"      13    199 ✗  160 ✓   133
 *   "R$ 1.284.500,00"    15    225 ✗  180 ✓   150
 *   "R$ 12.845.000,00"   16    242 ✗  194 ✗   161 ✓
 *
 * Daí os degraus abaixo. Degrau em vez de escala contínua porque o que importa
 * é caber, não ser proporcional.
 */
export function heroTotalSizeClass(formattedTotal: string): string {
  const length = formattedTotal.length;
  if (length <= 12) return 'text-3xl'; // até "R$ 99.999,99"
  if (length <= 15) return 'text-2xl'; // até "R$ 9.999.999,99"
  return 'text-xl';
}
